<template>
  <div class="app-loading">
    <img :src="logoImg" />
    <p>{{ step }}</p>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("biometrics", ["onNative"]),
    iOS() {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    code() {
      return this.getParam("code");
    },
    logoImg() {
      return process.env.VUE_APP_BASE_URL + "images/omint/logo-omint-app.png";
    }
  },
  data() {
    return {
      nextPage: "",
      step: "Validando dados para redirecionamento..."
    };
  },
  async mounted() {
    try {
      if ("localhost:8080" !== document.location.host && (this.iOS || !this.onNative) && "code" in this.$route.query) {
        const updated = await this.forceSWupdate();
        if (updated) {
          window.location.reload(true);
          setTimeout(() => this.getUrlThenRedirect(), 5000);
        } else {
          await this.getUrlThenRedirect();
        }
      } else {
        await this.getUrlThenRedirect();
      }
    } catch {
      this.linkInvalido();
    }
  },
  methods: {
    ...mapActions("saude", ["forceSWupdate", "getTempUrl"]),
    getParam(name) {
      if (this.$route.query[name]) return this.$route.query[name];
      if (this.$route.params[name]) return this.$route.params[name];
      return "";
    },
    linkInvalido() {
      this.step = "Link não localizado ou expirado";
      this.$router.replace("/login");
    },
    async getUrlThenRedirect() {
      try {
        await this.$root.$emit("hide-loading");
        if (!navigator.onLine || !this.code) {
          this.$router.replace("/login");
          return;
        }
        const url = await this.getTempUrl({ code: this.code });
        if (url) {
          this.step = "Redirecionando...";
          window.location = url;
          return;
        }
        this.linkInvalido();
      } catch {
        this.linkInvalido();
      }
    }
  }
};
</script>
<style scoped></style>
